module.exports = __webpack_public_path__ + "static/media/como-41.8af4721d.jpg";